export default __webpack_public_path__ + "static/media/physiotherapist-and-boy-holding-ball-150x84.84fa999b.png";